import { InMemoryDbService } from 'angular-in-memory-web-api';
import { ProductDB } from './products';
import { MailDB } from './mails';
import { CountryDB } from './countries';
import { ChatDB } from './chat-db';
import { InvoiceDB } from './invoices';
import { UserDB } from './users';
import { RoleDB } from './roles';
import { PoliceStationDB } from './police-stations';

export class InMemoryDataService implements InMemoryDbService {
  createDb() {
    return {
      'users': UserDB.users,
      'roles': RoleDB.roles,
      'police-station': PoliceStationDB.policeStations,
      'products': ProductDB.products,
      'invoices': InvoiceDB.invoices,
      'mails': MailDB.messages,
      'countries': CountryDB.countries,
      'contacts': ChatDB.contacts,
      'chat-collections': ChatDB.chatCollection,
      'chat-user': ChatDB.user
    };
  }
}
